import React from 'react'

const FormSectionHeader = ({ name }) => (
  <h2 className="mt-6 mb-6 font-bold u-p">{name}</h2>
)

export default FormSectionHeader
